import { merge } from 'lodash';

/* eslint-disable no-unused-vars */

// set up the default state for the module
const initialState = {
  show: false,
  performAction: false,
  settings: {
    title: 'Default',
    component: 'default',
    data: {},
  },
};

const actions = {
  openFullscreenModal: {
    root: true,
    handler({ commit, state }, payload) {
      commit('updateState', payload);
      commit('updatePerformAction', false);
      commit('openFullscreenModal');
    },
  },
  performActionFullscreenModal: {
    root: true,
    handler({ commit, state }, value) {
      commit('updatePerformAction', value);
    },
  },
  closeFullscreenModal: {
    root: true,
    handler({ commit, state }) {
      commit('resetStateData');
      commit('closeFullscreenModal');
    },
  },
};

const mutations = {
  openFullscreenModal(state) {
    state.show = true;
  },
  closeFullscreenModal(state) {
    state.show = false;
  },
  updateState(state, payload) {
    state.settings = merge(state.settings, payload);
  },
  updatePerformAction(state, value) {
    state.performAction = value;
  },
  resetStateData(state, payload) {
    state.settings.data = {};
  },
};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
